module.exports = __webpack_public_path__ + "img/the-starter-compare.b7d9eafe.png";